import { useEffect } from 'react';

/**
 * Locks the screen orientation to portrait while the calling page is mounted.
 *
 * The Screen Orientation API only works under specific conditions:
 *   • Chromium needs `display-mode: standalone` (PWA installed) OR fullscreen
 *   • Safari iOS does not support lock() at all
 *   • Rugged Android devices (Zebra TC27 etc.) in WebView CAN respect it
 *     when the WebView is configured as a PWA
 *
 * On devices where lock() throws / is unsupported, the CSS overlay in
 * `index.css` (the `.rotate-warn` media query in the calling page) acts
 * as a fallback: shows a "ruota in verticale" full-screen message.
 *
 * On unmount we release the lock so non-portalettere pages on the same
 * device behave normally.
 */
export function usePortraitLock() {
  useEffect(() => {
    let locked = false;
    const lock = async () => {
      try {
        if (typeof screen !== 'undefined' && screen.orientation && typeof screen.orientation.lock === 'function') {
          await screen.orientation.lock('portrait-primary');
          locked = true;
        }
      } catch (e) {
        // Many browsers reject lock() outside fullscreen / standalone PWAs.
        // Fail silently — the CSS overlay still shows when landscape.
      }
    };
    lock();
    return () => {
      if (locked) {
        try { screen.orientation.unlock(); } catch (e) { /* ignore */ }
      }
    };
  }, []);
}
